export interface IState {
	searchResult: ISearchResult
	query: string
	filter: string[]
	searchedQuery: string
	hitsPerPage: number,
	currentPage: number,
	endpoints: {
		searchURL: string
	},
	focus: IFocus,
	suggestion?: string,
	translations: ITranslations
}
export interface ITranslations {
	searchUKA: string
	allTypes: string
	showMore: string
	showing: string
	outOf: string
	pageTypePicked: string
	pageTypesPicked: string
	noHitsHeading: string
	tryThis: string
	checkSpelling: string
	trySynonym: string
	lessSpecificKeywords: string
	searchResultFor: string
	searchResult: string
	weFound: string
	hit: string
	hits: string
	matchingYourQuery: string
	didYouMean: string,
	placeholder: string
	searchButton: string
	clearButton: string
}
export interface IFocus {
	shouldFocus: boolean,
	index: number
}
export interface ISearchResult {
	searchHits: ISearchHit[],
	totalHits: number,
	suggestion?: string
}
export interface ISearchHit {
	type: string,
	category: string,
	title: string,
	breadcrumbs: string
}

const deafultState: IState = {
	filter: [],
	searchResult: {
		searchHits: [],
		totalHits: 0
	},
	query: '',
	searchedQuery: '',
	hitsPerPage: 10,
	currentPage: 0,
	endpoints: {
		searchURL: ''
	},
	focus: {
		shouldFocus: false,
		index: 0
	},
	suggestion: undefined,
	translations: {
		searchUKA: '',
		allTypes: '',
		showMore: '',
		showing: '',
		outOf: '',
		pageTypePicked: '',
		pageTypesPicked: '',
		noHitsHeading: '',
		tryThis: '',
		checkSpelling: '',
		trySynonym: '',
		lessSpecificKeywords: '',
		searchResultFor: '',
		searchResult: '',
		weFound: '',
		hit: '',
		hits: '',
		matchingYourQuery: '',
		didYouMean: '',
		placeholder: '',
		searchButton: '',
		clearButton: ''
	}
}

export default deafultState;
